// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QHlua","left":"styles_left__37jOI"};